import React from 'react';
import PropTypes from 'prop-types';

const AlertMessage = ({ type, message }) => {
  let classNames = 'alert-solid-success';
  let icon = <i className="feather-check-circle flex-shrink-0 me-2"></i>;
  if (type === 'info') {
    classNames = 'alert-solid-secondary';
    icon = <i className="feather-info flex-shrink-0 me-2"></i>;
  } else if (type === 'danger') {
    classNames = 'alert-solid-danger';
    icon = <i className="feather-alert-octagon flex-shrink-0 me-2"></i>;
  } else if (type === 'warning') {
    classNames = 'alert-solid-warning';
    icon = <i className="feather-alert-triangle flex-shrink-0 me-2"></i>;
  } else if (type === 'success') {
    classNames = 'alert-solid-success';
    icon = <i className="feather-check-circle flex-shrink-0 me-2"></i>;
  } else {
    classNames = 'alert-solid-primary';
    icon = <i className="feather-info flex-shrink-0 me-2"></i>;
  }

  return (
    <div className={`alert ${classNames} fade show d-flex align-items-center`} role="alert">
      {icon}
      <div>{message}</div>
    </div>
  );
};

AlertMessage.propTypes = {
  type: PropTypes.oneOf(['info', 'danger', 'warning', 'success', 'primary']).isRequired,
  message: PropTypes.string.isRequired,
};

export default AlertMessage;
